
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"mask0","maskUnits":"userSpaceOnUse","x":"2","y":"5","width":"16","height":"16"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 5h15.5v15.502H2V5z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#mask0)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.847 6.502c-.439 0-.722 0-.77.002a2.728 2.728 0 00-1.91.88 2.489 2.489 0 00-.664 1.805c0 2.893.001 7.235.008 7.473.114 1.385 1.412 2.444 2.898 2.33 2.75.004 6.824.013 7.015.006a2.726 2.726 0 001.908-.877 2.486 2.486 0 00.666-1.8v-.033c0-2.86 0-7.2-.007-7.432-.113-1.392-1.417-2.464-2.91-2.347-2.067-.003-4.886-.007-6.234-.007zm-.7 14c-2.115 0-3.959-1.62-4.133-3.744-.003-.041-.013-.166-.01-7.535A3.954 3.954 0 013.06 6.37a4.225 4.225 0 012.96-1.366c.14-.01 4.947.002 7.006.006 2.25-.158 4.281 1.512 4.462 3.753.008.109.011 2.634.01 7.509a3.976 3.976 0 01-1.06 2.863 4.222 4.222 0 01-2.962 1.36c-.14.01-4.95-.002-7.012-.006a4.224 4.224 0 01-.318.012z","fill":"#A4A8C0"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.818 18.35c-.451 0-.896-.156-1.263-.457l-3.281-2.696a.75.75 0 01.952-1.159l3.28 2.696c.22.18.443.106.529.064a.482.482 0 00.285-.449L21.332 9a.483.483 0 00-.285-.45.487.487 0 00-.53.065l-3.292 2.695a.748.748 0 01-1.055-.106.748.748 0 01.105-1.054l3.293-2.696a1.983 1.983 0 012.122-.259 1.982 1.982 0 011.142 1.807l-.012 7.35a1.981 1.981 0 01-1.144 1.803 1.995 1.995 0 01-.858.194z","fill":"#A4A8C0"}})])
          )
        }
      }
    